export const onLoginSuccess = () => ({
  type: "login-success",
})
